import React, { ReactElement } from 'react';
import { Popover } from '@bfe/moly';
import { ChainInfo } from '@/types/home';

import styles from './index.module.scss';

type Props = {
  children: ReactElement;
  chainList: ChainInfo[];
};

export const MultiChains = ({ children, chainList = [] }: Props) => {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Popover
        placement="bottomLeft"
        showArrow={false}
        overlayClassName={styles.popover}
        title={chainList?.map((chainInfo) => (
          <div key={chainInfo.chainId} className={styles.renderNode}>
            <div className={styles.renderNodeIcon}>
              <img src={chainInfo?.chainIcon} alt="icon" />
            </div>
            <div className={styles.renderNodeName}>{chainInfo?.chainName}</div>
          </div>
        ))}
      >
        {children}
      </Popover>
    </div>
  );
};
